import { TextField } from "@fluentui/react/lib/TextField";

import { useEditValue } from "../Hooks/UseEditValue";
import { IEditFieldProps } from "../IEditFieldProps";

export function EditMultiLine(props: IEditFieldProps): JSX.Element {
  const { htmlId, disabled } = props;
  const { errorMessage, value, onChange } = useEditValue<string>(props);
  return (
    <TextField
      id={htmlId}
      value={value}
      multiline
      onChange={onChange}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
}
